#ifdef GL_ES
precision mediump float;
#endif

uniform sampler2D u_tex;
uniform float     u_time;
uniform float     u_r;
uniform float     opacity;

varying float vRandomValue;
varying float vAngle;
varying vec3  vPos;

#pragma glslify: snoise = require('../partials/snoise.glsl')

#pragma glslify: fbm = require('../partials/fbm.glsl')


void main() {
    vec2 coord = gl_PointCoord - vec2(0.5, 0.5);
    float nBorder = snoise(coord * 2.0 + vRandomValue * 0.5);
    float distortion = nBorder * 0.4;
    coord += distortion;
    float dist = length(coord);
    if (dist > 0.5) discard;
    float gradient = smoothstep(0.2, 0.5, dist);

    vec2 st = gl_PointCoord - 0.5;
    float c = cos(vAngle), s = sin(vAngle);
    vec2 stRot = vec2(
      st.x * c - st.y * s,
      st.x * s + st.y * c
    );
    stRot.x *= -1.5;

    vec2 uv  = (vPos.xz / u_r) + 0.5;
    uv.x     = 1.0 - uv.x;

    vec4 baseC = texture2D(u_tex, uv);
    float phase = u_time - vAngle;
    float n = fbm(stRot * -4.0 + phase, vRandomValue);

    vec3 colorRGB = baseC.rgb * (0.5 + 0.5 * n);
    float alphaFinal = (1.0 - gradient) * n * baseC.a * opacity;

    gl_FragColor = vec4(colorRGB, alphaFinal);
}
